/* FOOTER TYPE */

import { SHIPPING_COMPANY } from 'swag-common/interfaces';
import { PRODUCTION_TIME_SAMPLE_DAYS, PRODUCTION_TIME_SAMPLE_TEXT, PRODUCTION_TIME_SAMPLE_VALUE } from 'swag-common/constants/product.constants';
export const FOOTER_MAIN = 1;
export const FOOTER_DASHBOARD = 2;
export const FOOTER_STICKY = 3;
export const FOOTER_PRODUCT = 4;

/* HEADER TYPE */
export const HEADER_MAIN = 1;
export const HEADER_DASHBOARD = 2;
export const HEADER_CATEGORY = 3;
export const HEADER_SEARCH_RESULTS = 4;
export const HEADER_PRODUCT_LISTING = 5;

/* PRICES */
export const PRICE_BASE = 1;
export const PRICE_SCREEN = 2;
export const PRICE_CATEGORY = 3;

/* PRODUCT BUILDER PAGE: CONTROL SECTION */
export const DEFAULT_ZINDEX = 10;
export const PRODUCT_BUILDER_MODES = {
  CREATE_MODE: 'create',
  REBUILD_MODE: 'rebuild',
  REORDER_MODE: 'reorder',
  REBUILD_MOCKUP_MODE: 'rebuildMockup',
  BUILD_MODE: 'build'
};
export let PAYMENT_STATES = /*#__PURE__*/function (PAYMENT_STATES) {
  PAYMENT_STATES["IDLE"] = "idle";
  PAYMENT_STATES["GATHERING_ADDRESS_INFO"] = "gatheringAddressInfo";
  PAYMENT_STATES["GATHERING_CARD_INFO"] = "gatheringCardInfo";
  PAYMENT_STATES["CONFIRMING"] = "confirming";
  PAYMENT_STATES["LOADING"] = "loading";
  PAYMENT_STATES["SUCCESS"] = "success";
  PAYMENT_STATES["ERROR"] = "error";
  PAYMENT_STATES["CONFIRM_FREE_ORDER"] = "confirmFreeOrder";
  PAYMENT_STATES["INVENTORY_PREFILLED_CARD"] = "inventoryPrefilledCard";
  PAYMENT_STATES["INVENTORY_SELECT_CARD"] = "inventorySelectCard";
  PAYMENT_STATES["INVENTORY_SELECT_CREDITS"] = "inventorySelectCredits";
  PAYMENT_STATES["INVENTORY_ENTER_PAYMENT_DETAILS"] = "enterPaymentDetails";
  PAYMENT_STATES["BUY_MORE_CREDITS"] = "buyMoreCredits";
  return PAYMENT_STATES;
}({});
export const PaymentScreenHeaders = {
  [PAYMENT_STATES.INVENTORY_SELECT_CARD]: 'Select a payment method',
  [PAYMENT_STATES.INVENTORY_PREFILLED_CARD]: 'Payment information',
  [PAYMENT_STATES.INVENTORY_ENTER_PAYMENT_DETAILS]: 'Enter payment details'
};

/* PRODUCT */
export const MAX_LOGO_COLORS = 8;
export const MAX_LOGO_COLORS_ROWS = 20;
export const PRINT_RUN_COLORS = new Array(MAX_LOGO_COLORS).fill(0).map((v, i) => i + 1);
export const GENERATE_PRINT_RUN_COLORS = size => new Array(size).fill(0).map((v, i) => i + 1);
export const MAX_PRINT_COLORS_LIMIT_ABSENT = 0;
export const PRODUCTION_TIME_STANDART_VALUE = 0;
export const PRODUCTION_TIME_STANDART_DAYS = 10;
export const PRODUCTION_TIME_STANDART_TEXT = 'Standard';
export const PRODUCTION_TIME_PRIORITY_VALUE = 0.1;
export const PRODUCTION_TIME_PRIORITY_DAYS = 5;
export const PRODUCTION_TIME_PRIORITY_TEXT = 'Priority';
export const PRODUCTION_TIME_VIP_VALUE = 0.25;
export const PRODUCTION_TIME_VIP_DAYS = 3;
export const PRODUCTION_TIME_VIP_TEXT = 'VIP';
export const PRODUCTION_TIME_LIST = [{
  name: PRODUCTION_TIME_STANDART_TEXT,
  cost: PRODUCTION_TIME_STANDART_VALUE,
  time: PRODUCTION_TIME_STANDART_DAYS
}, {
  name: PRODUCTION_TIME_PRIORITY_TEXT,
  cost: PRODUCTION_TIME_PRIORITY_VALUE,
  time: PRODUCTION_TIME_PRIORITY_DAYS
}, {
  name: PRODUCTION_TIME_SAMPLE_TEXT,
  cost: PRODUCTION_TIME_SAMPLE_VALUE,
  time: PRODUCTION_TIME_SAMPLE_DAYS
}, {
  name: PRODUCTION_TIME_VIP_TEXT,
  cost: PRODUCTION_TIME_VIP_VALUE,
  time: PRODUCTION_TIME_VIP_DAYS
}];
export const BLANK_PRODUCTION_TIME = {
  name: PRODUCTION_TIME_STANDART_TEXT,
  cost: PRODUCTION_TIME_STANDART_VALUE,
  time: PRODUCTION_TIME_STANDART_DAYS
};
/* IMAGE UPLOADING */
export const PLAIN_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png'];
export const IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const IMAGE_UPLOAD_ACCEPT = [...IMAGE_MIME_TYPES, PLAIN_IMAGE_EXTENSIONS].join(', ');
export const IMAGE_EXTENSIONS = ['.eps', '.ai', ...PLAIN_IMAGE_EXTENSIONS];
export const MIME_TYPES = [
// EPS
'application/postscript', 'application/eps', 'application/x-eps', 'image/eps', 'image/x-eps', ...IMAGE_MIME_TYPES];
export const LOGO_INPUT_ACCEPT = [...MIME_TYPES, ...IMAGE_EXTENSIONS].join(',');
export const SHIPPING_COMPANIES = {
  ups: {
    name: 'UPS',
    id: SHIPPING_COMPANY.UPS
  },
  fedex: {
    name: 'FedEx',
    id: SHIPPING_COMPANY.FEDEX
  },
  usps: {
    name: 'USPS',
    id: SHIPPING_COMPANY.USPS
  },
  dhl: {
    name: 'DHL',
    id: SHIPPING_COMPANY.DHL
  }
};
export const MAX_ATTACHMENTS_COUNT_PER_ITEM_FOR_CUSTOMER = 3;
export const MAX_ITEM_ATTACHMENT_FILE_SIZE = 10 * 1000000; // 10MB
export const MAX_IMAGE_FILE_SIZE = 2 * 1000000; // 2MB

export const MEDIA_TYPES = {
  TEXTS: 'texts',
  LOGOS: 'logos'
};
export const DEFAULT_PANTONE_COLORS = [{
  pms: 'black c',
  hex: '#000000'
}, {
  pms: 'white c',
  hex: '#ffffff'
}];
export const INFO_MESSAGE = {
  DONT_WORRY: {
    title: "Don't worry!",
    text: 'Every order is reviewed by a human. \n We will send you a mockup to \n approve after you place your order'
  },
  SHARED_ITEM_EDIT: {
    title: 'Keep in mind, ',
    text: "that if you make an edit here it will be applied to all of the same products in your cart whether it's a standalone product or in a box."
  }
};
export const HISTORY_DOC_TYPES = {
  ORDER: 'order',
  REWARD: 'reward',
  SIGNUP: 'signed_up',
  CORRECTION: 'correction'
};
export const SCROLL_DIRECTION = {
  up: 'up',
  down: 'down'
};
export const MINIMUM_ITEMS_FOR_BOX = 2;
export let mobMenuState = /*#__PURE__*/function (mobMenuState) {
  mobMenuState["CATEGORIES"] = "categories";
  mobMenuState["MAIN"] = "menu";
  mobMenuState["SUBCATEGORIES"] = "subcategories";
  return mobMenuState;
}({});
export const GIVEAWAY_VALIDATION_MESSAGES = {
  MIN_QUANTITY_CAP: 'Quantity cap needs to be at least 1',
  SELECT_AT_LEAST_ONE_COLOR: 'Please select at least one product color'
};
export const GIVEAWAY_STRINGS = {
  QUANTITY_CAP: 'Quantity cap',
  SET_A_CAP: 'Set a cap for how many each recipient can select'
};